/**
 * Палитра чипов справочников.
 *
 * Цвет значения — это данные, а не правило в CSS: его выбирают в
 * «Справочниках», и новое значение можно покрасить, не трогая код. Но выбор
 * ограничен восемью именами, а не произвольным кодом цвета: произвольный
 * позволяет завести серый текст на сером фоне, и в тёмной теме подобранная
 * вручную пара всё равно разъедется. Каждое имя раскрывается в пару
 * «фон + текст», подобранную для обеих тем (см. cells.css).
 */

export type ChipColor =
  | 'grey' | 'mint' | 'green' | 'yellow' | 'orange' | 'red' | 'blue' | 'violet'

export const CHIP_COLORS: readonly { value: ChipColor; label: string }[] = [
  { value: 'grey', label: 'Серый' },
  { value: 'mint', label: 'Мятный' },
  { value: 'green', label: 'Зелёный' },
  { value: 'yellow', label: 'Жёлтый' },
  { value: 'orange', label: 'Оранжевый' },
  { value: 'red', label: 'Красный' },
  { value: 'blue', label: 'Синий' },
  { value: 'violet', label: 'Фиолетовый' },
]

const KNOWN = new Set<string>(CHIP_COLORS.map((item) => item.value))

/** Цвет из базы → цвет палитры. Незнакомое имя и пустое значение — серый. */
export function chipColor(raw: string | null | undefined): ChipColor {
  return raw && KNOWN.has(raw) ? (raw as ChipColor) : 'grey'
}

export function chipColorLabel(raw: string | null | undefined): string {
  const color = chipColor(raw)
  return CHIP_COLORS.find((item) => item.value === color)?.label ?? 'Серый'
}
